export const urls = {
	private: `products?attributes=private-label`,
	cleanLabel: `products?attributes=clean-label%2Cvegan`,
	nexty: `products?whats_new=new&nexty_finalists=true`,
	newtoMarket: `products?whats_new=new&new_to_market=true`,
	minorityOwned: `products?secondLevelCategory=991175&firstLevelCategory=107&flatLevelCategory=10702%2C10703%2C10704%2C10705%2C10707%2C10708%2C9910740%2C9910741%2C10709%2C9910742%2C10710%2C10711%2C10712%2C9910730%2C1%2C9910737%2C9910738%2C9910743%2C9910732%2C10717%2C10718%2C9910733%2C10719%2C9910731%2C10720%2C9910734%2C9910735%2C9910739%2C9910736&attributes=minority-or-bipoc-owned`,
	kehe: `products?distributor=8`,
	seeAll: 'products',
	productsExpo: 'products?attributes=event'
};

export const content = {
	newTopiaTitle: 'Discover These Trending Product Categories at Newtopia Now',
	expowTitle: 'Discover These Trending Product Categories at Expo West'
};
